import Api from './api.service';

export default {
  destroy: (id) => Api.delete(`clients/${id}`),
  details: (id) => Api.get(`clients/${id}`),
  get: (params = {}) => Api.get('clients', { params }),
  put: (data, id) => Api.put(`clients/${id}`, data),
  store: (data) => Api.post('clients', data),
};
